import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ErrorHandler,
  Injectable,
  NgModule,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import {
  BuildConfigService,
  SharedUiComponentsModule,
} from '@dgx-pr-spa/ui-components';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RecaptchaV3Module } from 'ng-recaptcha';
import { AnalyticsModule } from './analytics/analytics.module';
import { CompareModule } from './compare/compare.module';
import { CompleteOrderModule } from './complete-order/complete-order.module';
import { CoreModule } from './core/core.module';
import { OptlyModule } from './optly/optly.module';
import { PagesModule } from './pages/pages.module';
import { RequestInterceptorService } from './shared/services/request.interceptor.service';
import { SharedModule } from './shared/shared.module';

export const configFactory = (buildConfigService: BuildConfigService) => {
  return (): Promise<void> => {
    return buildConfigService.loadConfig();
  };
};

@Injectable()
class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any) {
    if (window['QuantumMetricAPI']) {
      window['QuantumMetricAPI'].sendEvent(
        10064,
        0,
        new Date().getTime(),
        error
      );
    }

    console.error(error);
  }
}

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    PagesModule,
    CompareModule,
    CompleteOrderModule,
    StoreModule.forRoot([]),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument(),
    HammerModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaV3Module,
    AnalyticsModule,
    OptlyModule,
    SharedUiComponentsModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER, // ensure the application isn't started before the config file is loaded.
      useFactory: configFactory,
      deps: [BuildConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  exports: [RouterModule, SharedModule],
})
export class PrFeatureShellCommonModule {}
